export default "__VITE_ASSET__DvmpnqYm__"